document.addEventListener("DOMContentLoaded", () => {
    const video = document.getElementById("kitaVideo") as HTMLVideoElement | null;
    const playBtn = document.getElementById("playButton") as HTMLElement | null;

    if (video && playBtn) {
        //console.log("Video Exists");

        // Add class when video starts playing
        playBtn.addEventListener("click", () => {
            video.play();
        });

        // Remove class when video is paused or ended
        const onVideoEnd = () => {
            video.classList.remove("is-playing");
        };

        video.addEventListener("play", () => {
            video.classList.add("is-playing");
        });

        video.addEventListener("pause", onVideoEnd);

        video.addEventListener("ended", onVideoEnd);
    }
});



  